import { GetterTree } from "vuex/types/index"

import { RootState } from "~/store/store.types"
import { getResource } from "~/utils/store"

import { NotificationState, ShNotification, ShNotificationResource } from "./notification.types"

const getters: GetterTree<NotificationState, RootState> = {
  unreadNotifications (state): ShNotification[] {
    const [latestGroupId] = Object.keys(state.filters)
    const latestNotifications = state.filters[latestGroupId]

    if (Array.isArray(latestNotifications)) {
      return latestNotifications.map(id => getResource<ShNotificationResource>(state, id))
    }

    return []
  },

  showNotificationAlert ({ meta }): boolean {
    if (meta && meta.totalUnseenCount) {
      return meta.totalUnseenCount > 0
    }

    return false
  },

  pageCursorNext ({ meta }) {
    if (meta) {
      return meta.page.cursor.next
    }

    return null
  }
}

export default getters
